export default "__VITE_ASSET__BxQAdgWO__"